import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Action } from '../../rl-common/menu/action';
import { ApiService } from '../../rl-common/shared/shared/interfaces/api-service';
import { Section } from '../../store/model/section.model';

@Injectable({
  providedIn: 'root'
})
export class SectionService implements ApiService<Section>{
  //showInMenu('edit_section') 
  constructor(private http : HttpClient) { }

  getAll: (params : {listId?: string, sectionType? : 'CITATION' | 'ASSIGNMENT'}) => Observable<Section[]>;

  get = (listId : string, sid?: string) : Observable<Section> => this.http.get<Section>(`../rl/main/lists/${listId}/section/${sid}`);

  create = (section: Section) : Observable<Section> => this.http.post<Section>(`../rl/main/lists/${section.parentList}/sections`, section);

  save = (section: Section) : Observable<Section> => this.http.put<Section>(`../rl/main/lists/${section.parentList}/section/${section.id}`, section);

  delete = (section : Section) : Observable<any> => this.http.delete(`../rl/main/lists/${section.parentList}/sections/${section.id}`);

  getMenuOptions(section: Section): Action[] {
      let options : Action[] =[];

      if(section.locker) options = this._getLockedSectionOptions(section);
      
      options.push(new Action('edit', 'lists.section.edit_section'));
      options.push(new Action('addItems', section.type == 'CITATION' ? 'list.action.addItems' : 'list.action.addAssignments'));
      options.push(new Action('delete', 'list.section.action.delete', true));


      let ltiLink : Action = new Action('ltiLink');
      //ngif  && linkId && !section.locker && (!ltiLinkLegantoId || ltiLinkLegantoId != section.id)
      // labelarr {{'list.menu.action.lti_relink_from' | translate}} {{ltiSystemTypeLabel | translate}} {{'list.menu.action.lti_to_here' | translate}}
      ltiLink.popup = true;

      let deleteOption : Action;
      //ngif  && linkId && !section.locker && (!ltiLinkLegantoId || ltiLinkLegantoId != section.id)
      // labelarr {{'list.menu.action.lti_relink_from' | translate}} {{ltiSystemTypeLabel | translate}} {{'list.menu.action.lti_to_here' | translate}}

      return options;
  }

  _getLockedSectionOptions(section: Section): Action[] {
    let options : Action[] =[];

    return options;
  }

  //saveSectionSortOrder
  order = (sectionId : string, newOrder : number) => this.http.patch(`../rl/main/${sectionId}/order`, newOrder);
}